import { useNuxtApp } from '#app'; // Import useNuxtApp to access the app context

async function downloadFile(url, fileName) {
  const { $cmsApi } = useNuxtApp(); // Access the $cmsApi from the app context

  const data = await $cmsApi.get(url, null, { responseType: 'blob' });

  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(new Blob([data]));
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export default downloadFile;
